import React from 'react';
import { ConfigProvider, Layout as AntLayout } from 'antd';
import { Header } from './header';
import { Footer } from './footer';
import { Routes } from '../routes';
import { Maintenance } from './maintenance';
import { BrowserRouter } from 'react-router-dom';
import { UserContextProvider } from '../contexts';
import trTR from 'antd/lib/locale/tr_TR';

export function Layout() {
  const { Content } = AntLayout;
  const baseName = process.env.REACT_APP_MDM_BASE_NAME || '/app';

  return (
    <ConfigProvider locale={trTR}>
      <UserContextProvider>
        <BrowserRouter basename={baseName}>
          <AntLayout>
            <Maintenance>
              <Header />
              <Content style={{ padding: 0 }}>
                <div style={{ minHeight: 'calc(100vh - 64px)' }}>
                  <Routes />
                </div>
              </Content>
              <Footer />
            </Maintenance>
          </AntLayout>
        </BrowserRouter>
      </UserContextProvider>
    </ConfigProvider>
  );
}
